import { Chip, useTheme } from "@mui/material";
import type { FC } from "react";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import { CALCULATOR_CATALOG } from "web_myplann/Calculators/Utils/calculatorCatalog";
import { getCalculatorAreaColor } from "web_myplann/Calculators/Utils/getCalculatorAreaColor";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	type: CalculatorType;
	isLast: boolean;
	isEnabled: boolean;
	onClick: () => void;
};

export const CalculatorListRow: FC<Props> = ({
	type,
	isLast,
	isEnabled,
	onClick,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const { area, icon: Icon } = CALCULATOR_CATALOG[type];
	const { tint, ink } = getCalculatorAreaColor(theme.palette, area);

	return (
		<ListRow
			title={t(Resources.Calculators.Names[type])}
			subtitle={t(Resources.Calculators.Descriptions[type])}
			icon={
				<Icon
					aria-hidden
					size={theme.iconSize.md}
					color={isEnabled ? ink : theme.palette.grey[400]}
				/>
			}
			iconBg={isEnabled ? tint : theme.palette.grey[100]}
			isLast={isLast}
			dimmed={!isEnabled}
			onClick={onClick}
			showChevron={isEnabled}
			rightSlot={
				isEnabled ? undefined : (
					<Chip
						variant="tag"
						label={t(Resources.Calculators.Unavailable.Tag)}
					/>
				)
			}
		/>
	);
};
